import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * This directive is used to handle outside click for an element
 */
@Directive({
  selector: '[ideomClickOutside]',
})
export class ClickOutsideDirective {
  /**
   * This event emitter emits when outside click detected
   */
  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  /**
   * This method is used for handling document click event
   * @param target The element
   */
  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
